import { styled } from "@mui/material";

import type { ReactNode } from "react";

export interface TreeItemProps {
  label: ReactNode;
  "data-testid"?: string;
}

export function TreeItem({ label, "data-testid": dataTestId }: TreeItemProps) {
  return <Wrapper data-testid={dataTestId}>{label}</Wrapper>;
}

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  margin: theme.spacing(1.5, 1.5, 1.5, 3.5),
}));
